import {Observable} from 'rxjs';
import {CommonService} from '../../../shared/utils/common.service';
import {UtilsService} from '../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';
import {INotificacionesResponse} from '../modelos/INotificaciones';

@Injectable({
  providedIn: 'root',
})
export class NotificacionesService {
  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
  }

  obtener(): Observable<INotificacionesResponse[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.mantenimientoGaritas.obtenerTodo
      // TODO: Cambiarlo cuando tengamos el EndPint
      // this.url + this.diccionarioModulo.url.notificaciones.obtenerTodo
    );
  }

  obtenerPorId(idGarita: number): Observable<INotificacionesResponse> {
    return this._commom.peticionGetConHeader(
      this.url +
      this.diccionarioModulo.url.mantenimientoGaritas.obtenerPorId +
      idGarita
    );
  }

  crear(request: INotificacionesResponse) {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.mantenimientoGaritas.crear,
      request
    );
  }

  actualizar(request: INotificacionesResponse): Observable<any> {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.mantenimientoGaritas.actualizar,
      request
    );
  }

  borrar(idGarita: number): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url +
      this.diccionarioModulo.url.mantenimientoGaritas.eliminar +
      idGarita
    );
  }
}
